import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=b1ca19ba&scoped=true&"
import script from "./pagenation.vue?vue&type=script&lang=js&"
export * from "./pagenation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ca19ba",
  null
  
)

export default component.exports